
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SetupRouteService } from './setup-route.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { MANAGE_LINE_CONST } from '../common/core/common.constants';
import { UtilsService } from './utils.service';


@Injectable()
export class AccountManagementLoginGuard implements CanActivate {

    constructor(
        public setUpRouteSvc: SetupRouteService,
        private _router: Router,
        private utilsSvc: UtilsService
    ) { }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (isNullOrUndefined(this.utilsSvc.getContentDataFromSession())) {
            return this.setUpRouteSvc.tokenResolved().then((response) => {
                this._router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_HOME]);
            });
        } else {
            return true;
        }

    }
}
